import { React, useContext } from "react";
import { css } from "aphrodite";
import { Accordion, Card, AccordionContext } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";

export default function CustomAccordion({ children, eventKey, callback }) {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey, () => {

    let element = "";
    if (activeEventKey == 0 || activeEventKey === null || activeEventKey === undefined) {
      element = document.getElementById(eventKey);
      element.classList.add("is-open");
    } else {
      element = document.getElementById(activeEventKey);
      document.getElementById(eventKey).classList.add("is-open");
      element.classList.remove("is-open");
    }

    callback && callback(eventKey);
  });
  const isCurrentEventKey = activeEventKey === eventKey;
  return (
    <span
      style={{ cursor: "pointer" }}
      onClick={decoratedOnClick}
    >
      {children}
    </span>
  );
}

// export default function CustomAccordion() {
//   return (
//     <Accordion defaultActiveKey="0">
//       <Card style={{ border: "none" }}>
//         <Card.Header>
//           <ContextAwareToggle eventKey="1">
//             <i className="fa fa-filter fa-lg" />
//           </ContextAwareToggle>
//         </Card.Header>
//         <Accordion.Collapse eventKey="1" style={{
//           background: "rgb(113 163 229)",
//           }}>
//           <Card.Body>
//             {"Hi all..."}
//           </Card.Body>
//         </Accordion.Collapse>
//       </Card>
//     </Accordion>
//   );
// }
